
import Vue from "vue";

import { JsonSettingsLoadError } from "@/common/axshare/errors";

import { prop } from "@/components/utils";

export default Vue.extend({
  props: {
    error: prop(JsonSettingsLoadError, {
      required: true,
    }),
  },

  data() {
    return {
      showError: false,
    };
  },

  computed: {
    errorMessage(): string {
      return this.error ? this.error.message : "";
    },

    detailsMessage(): string {
      return this.showError ? "Hide Details" : "Show Details";
    },
  },

  methods: {
    onDetailsClicked() {
      this.showError = !this.showError;
    },
  },
});
